```html
<div class="backgroundImage">
    <app-header login='yes'></app-header>
    <div class="container">
        <div class="row">
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12">
            </div>


            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                <div class="sin-in-page-top">
                    <div class="card-wrapper">
                        <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
                            <div style="min-height: 500px;">
                                <app-sub-header title="Address"></app-sub-header>


                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group register-input">
                                            <label class="color" for="form_name">Primary Address</label>
                                            <input type="text" class="form-control" ngx-google-places-autocomplete
                                                (onAddressChange)="AddressChange($event)" placeholder="Primary Address"
                                                formControlName="primaryAddress">
                                            <div *ngIf="submitted && f.primaryAddress.errors" class="invalid-feedback"
                                                style="display: block;">
                                                <div *ngIf="f.primaryAddress.errors.required">{{errorMessage}}</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group register-input">
                                            <label class="color" for="form_name">Primary Address 2</label>
                                            <input type="text" class="form-control" ngx-google-places-autocomplete
                                                (onAddressChange)="AddressChange($event, 'primaryAddress2')"
                                                placeholder="Primary Address 2" formControlName="primaryAddress2">
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group register-input">
                                            <label class="color" for="form_name">Secondary Address</label>
                                            <input type="text" class="form-control" ngx-google-places-autocomplete
                                                (onAddressChange)="AddressChange($event, 'secondaryAddress')"
                                                placeholder="Secondary Address" formControlName="secondaryAddress">
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group register-input">
                                            <label class="color" for="form_name">Secondary Address 2</label>
                                            <input type="text" class="form-control" ngx-google-places-autocomplete
                                                (onAddressChange)="AddressChange($event, 'secondaryAddress2')"
                                                placeholder="Secondary Address 2" formControlName="secondaryAddress2">
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <br>
                            <button type="submit" class="btn btn-lg btn-block btn-primary">Next</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>